import { api } from '@/lib/api/client'

export type OrderStatus = 'PENDING' | 'CONFIRMED' | 'SHIPPING' | 'DELIVERED' | 'CANCELLED'
export type OrderPayment = 'COD' | 'QR'

export interface OrderItem {
  id: string
  productId: string
  slug: string
  name: string
  brand: string
  image: string
  price: number
  oldPrice: number
  qty: number
  lineTotal: number
}

export interface OrderAddress {
  fullName: string
  phone: string
  email: string
  province: string
  district: string
  ward: string
  street: string
  note?: string | null
}

export interface OrderStatusHistoryEntry {
  status: OrderStatus
  note?: string | null
  at: string
}

export interface Order {
  id: string
  code?: string
  userId?: string | null
  guest?: boolean
  status: OrderStatus
  payment: OrderPayment
  address: OrderAddress
  items: OrderItem[]
  subtotal: number
  discount: number
  shippingFee: number
  grandTotal: number
  statusHistory?: OrderStatusHistoryEntry[]
  createdAt: string
  updatedAt: string
}

export interface CreateOrderPayload {
  address: OrderAddress
  payment: OrderPayment
  items?: Array<{ productId: string; qty: number }>
}
export interface UpdateStatusPayload { status: OrderStatus; note?: string }
export interface OrderListQuery { page?: number; pageSize?: number; status?: OrderStatus | ''; q?: string }
export interface Paged<T> { items: T[]; total: number; page: number; pageSize: number }

export const ordersApi = {
  create:    (p: CreateOrderPayload)      => api.post<Order>('/orders', p),
  mine:      (q: OrderListQuery = {})     => api.get<Paged<Order>>('/orders/mine',  { params: q }),
  one:       (id: string)                 => api.get<Order>(`/orders/${id}`),
  adminList: (q: OrderListQuery = {})     => api.get<Paged<Order>>('/orders',       { params: q }),
  adminOne:  (id: string)                 => api.get<Order>(`/orders/${id}`),
  adminStatus: (id: string, p: UpdateStatusPayload) =>
    api.patch<Order>(`/orders/${id}/status`, p),
}
